module.exports = __webpack_public_path__ + "assets/img/s5-tab-3-c14a5a67.png";